import { render, staticRenderFns } from "./AppLimitedItems.vue?vue&type=template&id=0e3a99ca&scoped=true"
import script from "./AppLimitedItems.vue?vue&type=script&lang=js"
export * from "./AppLimitedItems.vue?vue&type=script&lang=js"
import style0 from "./AppLimitedItems.vue?vue&type=style&index=0&id=0e3a99ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3a99ca",
  null
  
)

export default component.exports